import { render, staticRenderFns } from "./GameDetailComponent.vue?vue&type=template&id=37215be5&scoped=true"
import script from "./GameDetailComponent.vue?vue&type=script&lang=js"
export * from "./GameDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./GameDetailComponent.vue?vue&type=style&index=0&id=37215be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37215be5",
  null
  
)

export default component.exports